import styles from './CourseDownloadButton.module.scss';
import { HoverUnderlineWrapper, Underline } from '@/components';
import { RouteSticker } from '@/components';
import { useState } from 'react';

const CourseDownloadButton = ({ type, mapURL }) => {
  const [isStopped, setIsStopped] = useState(true);
  return (
    <HoverUnderlineWrapper isLink={true} underlineColor={'#fff'} height={'2'}>
      <a
        className={styles.container}
        href={mapURL}
        tabIndex={0}
        onMouseEnter={() => setIsStopped(false)}
        onMouseLeave={() => setIsStopped(true)}
        onFocus={() => setIsStopped(false)}
        onBlur={() => setIsStopped(true)}
        download
      >
        {/* <div className={styles.bubble}>NPC를 찾아 보상을 수령하세요!</div> */}
        <RouteSticker className={styles.sticker} type={type} isStopped={isStopped} />
        <div className={styles.downloadButton}>
          <Underline className={styles.underline} wrapperTag={'div'}>
            맵 다운로드
          </Underline>
        </div>
      </a>
    </HoverUnderlineWrapper>
  );
};
export default CourseDownloadButton;
